function abrir(identificador, callback, chave) {
    window.dispatchEvent(
        new CustomEvent("confirmacao-open", {
            bubbles: true,
            detail: {
                identificador,
                callback,
                chave
            }
        })
    )
}

function fechar(identificador, confirmou) {
    window.dispatchEvent(
        new CustomEvent("confirmacao-close", {
            bubbles: true,
            detail: {
                identificador,
                confirmou
            }
        })
    )
}

let BussolaUiConfirmacao = {
    abrir, fechar
}

export default BussolaUiConfirmacao


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/confirmacao.js